export const LSIMTokenName = 'im_user_token';
export const LSUser = 'im_user';
